<template>
  <v-img :src="worldMap" />
</template>

<script>
import samsaraMap from '../../assets/Samsara.jpg';

export default {
  data() {
    return {
      worldMap: samsaraMap
    };
  }
};
</script>

<style>

</style>